import { Controller } from "@hotwired/stimulus"

// Confirm controller: shows a confirm() prompt before letting an action through.
//
// Usage on a destructive button/link:
//   = button_to "Delete", path, method: :delete,
//       data: {
//         controller: "confirm",
//         confirm_message_value: "Are you sure?",
//         action: "submit->confirm#prompt",
//       }
//
// Or on a free-standing button paired with other controllers:
//   = button_tag "Delete",
//       data: {
//         controller: "confirm callback",
//         confirm_message_value: "Are you sure?",
//         callback_name_value: "removeItem",
//         action: "click->confirm#prompt click->callback#invoke",
//       }
//
// When the user cancels, `event.preventDefault()` + `stopImmediatePropagation()`
// are called, so any subsequent Stimulus actions on the same event (e.g.
// `callback#invoke`) do NOT run. When confirmed, the event proceeds normally.
export default class extends Controller {
  static values = {
    message: { type: String, default: "Are you sure?" },
  }

  prompt(event) {
    if (!window.confirm(this.messageValue)) {
      event.preventDefault()
      if (typeof event.stopImmediatePropagation === "function") {
        event.stopImmediatePropagation()
      }
    }
  }
}
